.link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: var(--target-min);
  padding: 0 6px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: transparent;
  color: var(--accent);
  font-size: var(--t-min);
  font-weight: 600;
  /* One line: in a narrow grid cell "Basis and limits" wrapped to two (G-Wviewer-27), and the cell is the
     link's own width, so it overflows its column instead. */
  white-space: nowrap;
  cursor: pointer;
}

.link:hover {
  background: var(--accent-w);
  color: var(--accent-h);
}

.link:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.text {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-body);
  line-height: 1.5;
}
